import React, { useState } from 'react'
import Img from 'gatsby-image/withIEPolyfill'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Fade, Slide } from '@material-ui/core'

import VizSensor from 'react-visibility-sensor'

const AboutInfo = props => {
  let [active, setActive] = useState(false)
  return (
    <VizSensor
      onChange={isVisible => {
        setActive(isVisible)
      }}
      partialVisibility
    >
      <Fade in={active} timeout={2000}>
        <section className="aboutContainer">
          <Img
            className="aboutImage"
            alt={props.alt}
            fluid={props.image}
            objectFit="cover"
          />
          {props.classprop === 'aboutInfoTwo' ? (
            <Slide in={active} direction="right" timeout={1500}>
              <div className={props.classprop}>
                {documentToReactComponents(props.text)}
              </div>
            </Slide>
          ) : (
            <Slide in={active} direction="left" timeout={1500}>
              <div className={props.classprop}>
                {documentToReactComponents(props.text)}
              </div>
            </Slide>
          )}
        </section>
      </Fade>
    </VizSensor>
  )
}

export default AboutInfo
